import React from 'react';
import { Checkbox as AntdCheckbox, CheckboxProps } from 'antd';
import styled from 'styled-components';
import theme from '@config/theme';

interface ComponentProps extends CheckboxProps {
  size?: 'small' | 'default';
  margin?: string;
  fontSize?: string;
}

const StyledCheckbox = styled(AntdCheckbox)<ComponentProps>`
  margin: ${(props) => props.margin || '0'} !important;
  
  &.ant-checkbox-wrapper {
    font-size: ${(props) => props.fontSize || 'inherit'};
  }
  
  &.ant-checkbox-disabled {
    cursor: not-allowed;
    & span {
      color: ${theme.palette.neutral.black} !important;
    }
  }
  .ant-checkbox-inner {
    width: ${(props) => props.size === 'small' ? '16px' : '20px'};
    height: ${(props) => props.size === 'small' ? '16px' : '20px'};
    border-radius: 4px;
    border: 1.5px solid ${theme.palette.primary.hue};
    &:active {
      border: 1.5px solid ${theme.palette.primary.hue};
    }
    &:hover {
      border: 1.5px solid ${theme.palette.primary.hue};
    }
    &:focus {
      border: 1.5px solid ${theme.palette.primary.hue};
    }
  }
  .ant-checkbox-checked > .ant-checkbox-inner {
    background-color: ${theme.palette.primary.hue};
    &::after {
      width: ${(props) => props.size === 'small' ? '6px' : '7px'};
      height: ${(props) => props.size === 'small' ? '10px' : '12px'};
      top: ${(props) => props.size === 'small' ? '6px' : '8px'};
      left: ${(props) => props.size === 'small' ? '3px' : '4px'};
    }
    border: 1px solid ${theme.palette.primary.hue};
  }

  .ant-checkbox > span {
    &:first-of-type {
      position: relative;
      top: 2px;
    }
  }

  .ant-checkbox-checked::after {
    border: none;
  }
  
`;

const Checkbox = ({ ...props }: ComponentProps) => {
  return <StyledCheckbox {...props} />;
};

export default Checkbox;


